import { useEffect } from 'react';

export const useTopScroll = (): void => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};
